import { IconOptions } from 'primereact/utils';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const PushedCertificateIcon = (options: IconOptions) => {
  return (
    <svg width='24' height='24' viewBox='0 0 64 64' xmlns='http://www.w3.org/2000/svg' {...options}>
      <g transform='translate(0,64) scale(0.1,-0.1)' fill='currentColor' stroke='none'>
        <path d='M310 453 l0 -127 -33 32 c-31 30 -57 41 -57 24 0 -4 23 -30 50 -57 l50 -49 50 49 c28 27 50 53 50 57 0 17 -26 6 -57 -24 l-33 -32 0 127 c0 78 -4 127 -10 127 -6 0 -10 -49 -10 -127z' />
        <path d='M86 366 c-46 -82 -46 -84 -46 -179 0 -91 1 -96 26 -116 25 -20 39 -21 254 -21 215 0 229 1 254 21 25 20 26 25 26 118 0 93 -2 101 -40 179 l-39 82 -41 0 c-49 0 -52 -23 -4 -28 26 -3 35 -12 57 -58 15 -30 27 -59 27 -64 0 -6 -24 -10 -53 -10 -50 0 -56 -3 -90 -40 -34 -38 -38 -40 -97 -40 -59 0 -63 2 -97 40 -34 37 -40 40 -90 40 -29 0 -53 3 -53 6 0 4 14 33 32 65 24 43 38 59 57 61 40 5 38 28 -3 28 -34 0 -37 -3 -80 -84z m109 -122 c14 -15 25 -30 25 -34 0 -14 53 -30 100 -30 47 0 100 16 100 30 0 4 11 19 25 34 20 21 33 26 75 26 l50 0 0 -89 c0 -72 -3 -90 -16 -95 -20 -8 -448 -8 -468 0 -13 5 -16 23 -16 95 l0 89 50 0 c42 0 55 -5 75 -26z' />
      </g>
    </svg>
  );
};

export default PushedCertificateIcon;
